import InventoryEditDocuments from './InventoryEditDocuments'
export default InventoryEditDocuments
